import ModuleOrders from 'mfOrderManagement/Orders';

/**
 * Simple re-export of the orders module, allowing for mocks
 * (the promise-based alias 'mfOrderManagement/*' can't be mocked directly) to be used in tests
 */
export { ModuleOrders };
